import React from "react";
import { useAuth0 } from "@auth0/auth0-react";
import { useFlags } from "launchdarkly-react-client-sdk";

import { Button as MUIButton, Typography } from "@mui/material";

import Button from "components/common/Button";

import EdgeLogo from "components/Design/EdgeLogo/EdgeLogo";

import "components/Screens/Login/SignUp/Auth0Login/Auth0Login.scss";

function Auth0Login() {
  const { loginWithRedirect } = useAuth0();
  const { loginRebrand } = useFlags();

  return loginRebrand ? (
    <Button
      variant="contained"
      data-testid="auth0-login-button"
      size="large"
      isFullWidth
      startIcon={<EdgeLogo icon state="white" />}
      label="Continue with Edge ID"
      onClick={() => {
        loginWithRedirect();
      }}
    />
  ) : (
    <MUIButton
      data-testid="auth0-login-button"
      variant="contained"
      fullWidth
      onClick={() => {
        loginWithRedirect();
      }}
      className="auth0-button"
    >
      <div className="auth0-button-logo">
        <EdgeLogo icon />
      </div>
      <Typography>Continue with Edge</Typography>
    </MUIButton>
  );
}

export default Auth0Login;
